import { gql } from '@apollo/client';
import { GetSuggestionFragment } from '../utils/suggestionFragment';
export const CreateSuggestionFragment = gql `
  fragment CreateSuggestionFragment on FileSystemDocumentSuggestion {
    ...GetSuggestionFragment
  }
  ${GetSuggestionFragment}
`;
